import { render } from "./ExpandGroup.vue?vue&type=template&id=18f45388&scoped=true&lang=pug"
import script from "./ExpandGroup.vue?vue&type=script&lang=js"
export * from "./ExpandGroup.vue?vue&type=script&lang=js"

import "./ExpandGroup.vue?vue&type=style&index=0&id=18f45388&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f45388"]])

export default __exports__